/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiUsersConsumerUserIdDelete } from '../fn/users/api-users-consumer-user-id-delete';
import { ApiUsersConsumerUserIdDelete$Params } from '../fn/users/api-users-consumer-user-id-delete';
import { apiUsersConsumerUserIdPut } from '../fn/users/api-users-consumer-user-id-put';
import { ApiUsersConsumerUserIdPut$Params } from '../fn/users/api-users-consumer-user-id-put';
import { apiUsersPost$Json } from '../fn/users/api-users-post-json';
import { ApiUsersPost$Json$Params } from '../fn/users/api-users-post-json';
import { apiUsersPost$Plain } from '../fn/users/api-users-post-plain';
import { ApiUsersPost$Plain$Params } from '../fn/users/api-users-post-plain';
import { apiUsersUserCompanyCodeGet$Json } from '../fn/users/api-users-user-company-code-get-json';
import { ApiUsersUserCompanyCodeGet$Json$Params } from '../fn/users/api-users-user-company-code-get-json';
import { apiUsersUserCompanyCodeGet$Plain } from '../fn/users/api-users-user-company-code-get-plain';
import { ApiUsersUserCompanyCodeGet$Plain$Params } from '../fn/users/api-users-user-company-code-get-plain';
import { User } from '../models/user';

@Injectable({ providedIn: 'root' })
export class UsersService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiUsersUserCompanyCodeGet()` */
  static readonly ApiUsersUserCompanyCodeGetPath = '/api/Users/{userCompanyCode}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUsersUserCompanyCodeGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiUsersUserCompanyCodeGet$Plain$Response(params: ApiUsersUserCompanyCodeGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<User>>> {
    return apiUsersUserCompanyCodeGet$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUsersUserCompanyCodeGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiUsersUserCompanyCodeGet$Plain(params: ApiUsersUserCompanyCodeGet$Plain$Params, context?: HttpContext): Observable<Array<User>> {
    return this.apiUsersUserCompanyCodeGet$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<User>>): Array<User> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUsersUserCompanyCodeGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiUsersUserCompanyCodeGet$Json$Response(params: ApiUsersUserCompanyCodeGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<User>>> {
    return apiUsersUserCompanyCodeGet$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUsersUserCompanyCodeGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiUsersUserCompanyCodeGet$Json(params: ApiUsersUserCompanyCodeGet$Json$Params, context?: HttpContext): Observable<Array<User>> {
    return this.apiUsersUserCompanyCodeGet$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<User>>): Array<User> => r.body)
    );
  }

  /** Path part for operation `apiUsersPost()` */
  static readonly ApiUsersPostPath = '/api/Users';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUsersPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUsersPost$Plain$Response(params?: ApiUsersPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<User>> {
    return apiUsersPost$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUsersPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUsersPost$Plain(params?: ApiUsersPost$Plain$Params, context?: HttpContext): Observable<User> {
    return this.apiUsersPost$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<User>): User => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUsersPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUsersPost$Json$Response(params?: ApiUsersPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<User>> {
    return apiUsersPost$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUsersPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUsersPost$Json(params?: ApiUsersPost$Json$Params, context?: HttpContext): Observable<User> {
    return this.apiUsersPost$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<User>): User => r.body)
    );
  }

  /** Path part for operation `apiUsersConsumerUserIdPut()` */
  static readonly ApiUsersConsumerUserIdPutPath = '/api/Users/{consumerUserId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUsersConsumerUserIdPut()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUsersConsumerUserIdPut$Response(params: ApiUsersConsumerUserIdPut$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiUsersConsumerUserIdPut(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUsersConsumerUserIdPut$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  apiUsersConsumerUserIdPut(params: ApiUsersConsumerUserIdPut$Params, context?: HttpContext): Observable<void> {
    return this.apiUsersConsumerUserIdPut$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiUsersConsumerUserIdDelete()` */
  static readonly ApiUsersConsumerUserIdDeletePath = '/api/Users/{consumerUserId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiUsersConsumerUserIdDelete()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiUsersConsumerUserIdDelete$Response(params: ApiUsersConsumerUserIdDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiUsersConsumerUserIdDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiUsersConsumerUserIdDelete$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiUsersConsumerUserIdDelete(params: ApiUsersConsumerUserIdDelete$Params, context?: HttpContext): Observable<void> {
    return this.apiUsersConsumerUserIdDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
